import { ExclusionsToSelect } from './Product.types';
import { Exclusion, Product } from '../../sections/Products/Products.types';
import { Dispatch } from '@reduxjs/toolkit';
import { addProduct } from '../../store/cart/cart.reducers';
import { PinterestTag } from '../../helpers/pinterest';
import { GtmTag } from '../../helpers/gtm';

export const adaptToSelect = (input: Exclusion[]): ExclusionsToSelect[] => {
  return input.map(item => ({
    value: item.id,
    label: item.name,
  }));
};

export const adaptFromSelect = (input: ExclusionsToSelect[]): Exclusion[] => {
  return input.map(item => ({
    id: item.value,
    name: item.label,
  }));
};

export type CartChoice = {
  amount: number;
  start_date: string;
  frequency_id: number;
  exclusions: Exclusion[];
};

export const addToCart = (dispatch: Dispatch, title: string, product: Product, choice: CartChoice) => {
  const frequency = product.available_frequencies.find(item => item.frequency_id === choice.frequency_id);
  dispatch(
    addProduct({
      quantity: choice.amount.toString(),
      start_date: choice.start_date,
      frequency_id: choice.frequency_id,
      frequency: frequency?.name || '',
      product_variant_id: product.product_variant_id,
      price: product.price,
      size: product.size,
      title,
      img: product.image_url,
      exclusions: choice.exclusions,
    }),
  );
  const tracked = {
    product_id: product.product_variant_id.toString(),
    product_name: `${title} - ${product.size}`,
    value: product.price * choice.amount,
    quantity: choice.amount,
  };
  PinterestTag.addToCart(tracked);
  GtmTag.addToCart(tracked);
};
